import { Box } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DEFAULT_DRAG_HANDLE_SELECTOR } from "../../../app/constants";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import { RoundedButton } from "../../../common/components/styled/styled";
import { leadingZerosDateFormat } from "../../../common/helpers/formatDateTime";

type Props = {
  isOpen: boolean;
  onAccept: (selectedDate: Date) => void;
  onCancel: () => void;
  selectedDate: Date | null;
  label: string;
};

export const ValidFromDateModal = ({
  isOpen,
  onAccept,
  onCancel,
  selectedDate,
  label,
}: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<Date | null>(selectedDate);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(isOpen);

  const handleChange = (newValue: Date | null) => {
    setValue(newValue);
  };

  const accept = () => {
    if (value) {
      onAccept(value);
    }
  };

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  return (
    <DialogComponent
      open={isModalOpen}
      onClose={() => {
        setIsModalOpen(false);
      }}
    >
      <Box
        className={DEFAULT_DRAG_HANDLE_SELECTOR}
        sx={{ display: "flex", flexDirection: "column", cursor: "grab" }}
      >
        <DesktopDatePicker
          label={t("date")}
          format={leadingZerosDateFormat}
          value={value}
          onChange={handleChange}
        />
        <Box mt={1}>
          <RoundedButton onClick={onCancel}>{t("cancel")}</RoundedButton>
          <RoundedButton
            variant="contained"
            disabled={value === null}
            onClick={accept}
          >
            {label}
          </RoundedButton>
        </Box>
      </Box>
    </DialogComponent>
  );
};
